"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPath = exports.sanitizeURL = exports.sanitizeParams = exports["default"] = exports.createTransport = exports.createTrack = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _axios = _interopRequireDefault(require("axios"));

var _queryString = _interopRequireDefault(require("query-string"));

var _uuid = _interopRequireDefault(require("./uuid"));

var _agni = _interopRequireDefault(require("@guestyci/agni"));

var _user = require("./user");

var _schema = require("./schema");

var _fetch = _interopRequireDefault(require("./fetch"));

var _token = require("./token");

var publicApiKey = 'BPxVZlZ4gbxVjb3aMg6on00Yg2c6DHkveDHTvdKNNR4GTjJP0Afchelf';
var publicAuthHeader = 'trackapikey';
var user;

var createLogger = function createLogger(debug) {
  return function (msg, level) {
    if (!debug) {
      return;
    }

    if (level === 'info') {
      console.log(msg);
      return;
    }

    console.error(msg);
  };
};

var sanitizeParams = function sanitizeParams(value) {
  if (!value) {
    return null;
  }

  try {
    var parsed = _queryString["default"].parse(value);

    if (parsed.token) {
      delete parsed.token;
    }

    return _queryString["default"].stringify(parsed);
  } catch (e) {
    return null;
  }
};

exports.sanitizeParams = sanitizeParams;

var sanitizeURL = function sanitizeURL(referrer) {
  if (!referrer.includes('token')) {
    return referrer;
  }

  try {
    var _URL = new URL(referrer),
        search = _URL.search,
        hash = _URL.hash;

    var parsedSearch = _queryString["default"].parse(search);

    var parsedHash = _queryString["default"].parse(hash);

    if (parsedHash) {
      delete parsedHash.token;
    }

    if (parsedSearch) {
      delete parsedSearch.token;
    }

    var base = referrer.split('?')[0].split('#')[0];

    var newSearch = _queryString["default"].stringify(parsedSearch, {
      encode: false
    });

    var newHash = _queryString["default"].stringify(parsedHash, {
      encode: false
    });

    var sanitized = "".concat(base).concat(newSearch ? "?".concat(newSearch) : '').concat(newHash ? "#".concat(newHash) : '');
    return sanitized;
  } catch (e) {
    return '';
  }

  return referrer;
};

exports.sanitizeURL = sanitizeURL;

var http = function http() {
  var _window$location = window.location,
      pathname = _window$location.pathname,
      search = _window$location.search,
      hash = _window$location.hash,
      host = _window$location.host,
      protocol = _window$location.protocol,
      href = _window$location.href,
      hostname = _window$location.hostname;
  var _document = document,
      referrer = _document.referrer,
      title = _document.title;
  return {
    http: {
      userAgent: navigator.userAgent,
      path: pathname,
      url: "".concat(protocol, "//").concat(host).concat(pathname),
      referrer: sanitizeURL(referrer),
      search: sanitizeParams(search),
      hash: sanitizeParams(hash),
      href: sanitizeURL(href),
      hostname: hostname,
      title: title
    }
  };
};

var tracker = function tracker() {
  var packageJson;

  try {
    packageJson = require("".concat(__dirname, "/package.json"));
  } catch (e) {}

  var _ref = packageJson || {
    name: '@guestyci/dio',
    version: 'unknown'
  },
      name = _ref.name,
      version = _ref.version;

  return {
    tracker: {
      name: name,
      version: version
    }
  };
};

var createCustomEnrichment = function createCustomEnrichment() {
  var enrichments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var log = arguments.length > 1 ? arguments[1] : undefined;
  return Object.keys(enrichments).reduce(function (acc, key) {
    var enrichment = enrichments[key];

    if ((0, _typeof2["default"])(enrichment) === 'object') {
      acc[key] = enrichment;
      return acc;
    }

    if (typeof enrichment === 'function') {
      var value = enrichment();

      if ((0, _typeof2["default"])(value) !== 'object') {
        log('An enrichment function returned a value which was not an object. Enrichment data will not be sent.');
        return acc;
      }

      acc[key] = value;
      return acc;
    }

    log('An enrichment was not an object. Enrichment data will not be sent.');
  }, {});
};

var enrich = function enrich(provider, enrichments, log) {
  var customEnrichment = createCustomEnrichment(enrichments, log);

  if (provider === 'mobile') {
    return (0, _extends2["default"])({
      provider: 'mobile '
    }, customEnrichment);
  }

  return (0, _extends2["default"])({
    provider: 'webclient'
  }, http(), customEnrichment);
};

var isNestedObject = function isNestedObject(obj) {
  return !Object.keys(obj).some(function (key) {
    return typeof obj[key] !== 'function' && (0, _typeof2["default"])(obj[key]) !== 'object';
  });
};

var trackPath = function trackPath(provider, isPublic) {
  var path = provider === 'mobile' ? 'track/mobile' : 'track/web';
  return isPublic ? "/public/".concat(path) : "/".concat(path);
};

exports.trackPath = trackPath;

var identify = function identify(_ref2) {
  var userId = _ref2.userId,
      accountId = _ref2.accountId,
      orgId = _ref2.orgId,
      hqUserId = _ref2.hqUserId,
      email = _ref2.email,
      fullName = _ref2.fullName;

  if (orgId) {
    user = {
      orgId: orgId,
      hqUserId: hqUserId,
      fullName: fullName,
      email: email
    };
  } else {
    user = {
      userId: userId,
      accountId: accountId,
      fullName: fullName,
      email: email
    };
  }
};

var determineProvider = function determineProvider() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.gfhPlatform === 'mobile')) {
    return 'mobile';
  } else if (typeof document !== 'undefined') {
    return 'webclient';
  }

  return undefined;
};

var createTransport = function createTransport(_ref3) {
  var baseURL = _ref3.baseURL,
      token = _ref3.token,
      isPublic = _ref3.isPublic;
  var parsedToken = token ? token : (0, _token.getToken)();
  var requestHeaders = isPublic ? (0, _defineProperty2["default"])({}, publicAuthHeader, publicApiKey) : {
    Authorization: "Bearer ".concat(parsedToken)
  };
  return new _fetch["default"]({
    baseURL: baseURL,
    headers: (0, _extends2["default"])({}, requestHeaders)
  });
};

exports.createTransport = createTransport;

var init = function init(_ref5) {
  var context = _ref5.context,
      baseUrl = _ref5.baseUrl,
      _ref5$bearerToken = _ref5.bearerToken,
      bearerToken = _ref5$bearerToken === void 0 ? null : _ref5$bearerToken,
      _ref5$debug = _ref5.debug,
      debug = _ref5$debug === void 0 ? false : _ref5$debug,
      _ref5$transport = _ref5.transport,
      transport = _ref5$transport === void 0 ? null : _ref5$transport,
      _ref5$isPublic = _ref5.isPublic,
      isPublic = _ref5$isPublic === void 0 ? false : _ref5$isPublic,
      _ref5$enrichments = _ref5.enrichments,
      enrichments = _ref5$enrichments === void 0 ? {} : _ref5$enrichments;

  if (!context || typeof context !== 'string') {
    throw new Error('Context is mandatory when initializing the tracker.');
  }

  if (!transport && (!baseUrl || typeof baseUrl !== 'string')) {
    throw new Error('baseUrl mandatory when initializing the tracker.');
  }

  if (enrichments && !isNestedObject(enrichments)) {
    throw new Error('Enrichments must be a nested object.');
  }

  var logger = createLogger(debug);
  var provider = determineProvider();
  user = (0, _user.anonymousUserData)(provider);

  if (bearerToken) {
    user = (0, _extends2["default"])({}, user, (0, _user.getUserDataFromToken)(bearerToken));
  } else {
    user = (0, _extends2["default"])({}, user, _agni["default"].getCurrentUser());
  }

  return {
    track: createTrack({
      transport: transport || createTransport({
        baseURL: baseUrl,
        token: bearerToken,
        isPublic: isPublic
      }),
      context: context,
      path: trackPath(provider, isPublic),
      provider: provider,
      enrichments: enrichments,
      logger: logger
    }),
    identify: identify
  };
};

var createTrack = function createTrack(_ref6) {
  var transport = _ref6.transport,
      path = _ref6.path,
      context = _ref6.context,
      provider = _ref6.provider,
      enrichments = _ref6.enrichments,
      log = _ref6.logger;

  var track = function track(eventName, type, properties, customContext) {
    if (!eventName) {
      throw new Error('Warning: Did not send track information.\nEvent name is required when sending an event.');
    }

    if (!(0, _schema.isTypeAllowed)(type)) {
      throw new Error("Warning: Did not send track information.\nPlease supply a valid type of the following:\n ".concat((0, _toConsumableArray2["default"])(_schema.types).join(', ')));
    }

    var timestamp = new Date().toISOString();
    var eventData = Object.assign({
      eventName: eventName,
      type: type
    }, {
      context: customContext || context
    });

    if (typeof properties === 'string') {
      eventData['target'] = properties;
    } else {
      try {
        eventData['properties'] = JSON.stringify((0, _extends2["default"])({}, properties));
      } catch (e) {
        log('Could not stringify event properties');
      }
    }

    var completePayload = createPayload({
      tracker: tracker,
      eventData: eventData,
      user: user,
      enrichment: (0, _extends2["default"])({}, enrich(provider, enrichments, log)),
      timestamp: timestamp
    });
    log("Dio sending event with data:\n\nContext: ".concat(eventData.context, "\nType: ").concat(type, "\n\nName: ").concat(eventName, "\nTarget: ").concat(eventData.target, "\nProperties: ").concat(eventData.properties, "\n"), 'info');
    transport.post(path, completePayload).then(function (res) {
      return log("Dio Sent ".concat(eventName, " successfully"), 'info');
    })["catch"](function (e) {
      return log("Failed to send ".concat(eventName));
    });
  };

  return track;
};

exports.createTrack = createTrack;

var createPayload = function createPayload(_ref7) {
  var tracker = _ref7.tracker,
      eventData = _ref7.eventData,
      user = _ref7.user,
      enrichment = _ref7.enrichment,
      timestamp = _ref7.timestamp;
  return (0, _extends2["default"])({}, tracker(), eventData, {
    user: user
  }, enrichment, {
    eventTimestamp: timestamp,
    messageId: (0, _uuid["default"])(),
    sentAt: new Date().toISOString()
  });
};

var _default = {
  init: init
};
exports["default"] = _default;